const getProductCards = (root = document) => {
  const selector = '.card.card--standard.card--media';
  return [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
};

const update_swatch_img = (root = document) => {
  let cards = getProductCards(root);
  cards.forEach((card) => {
    let featured_img = card.querySelector('.card__media .media img.feat-main');
    let featured_img_alt = card.querySelector('.card__media .media img.feat-alt');
    let prod_link = card.querySelector('.card__content .card__information .card__heading.h5 a.full-unstyled-link');
    card.querySelectorAll('.product-card-swatch-button').forEach((control) => {
      if (control.dataset.swatchImageBound) return;
      control.dataset.swatchImageBound = 'true';
      control.addEventListener('click', () => {
        const swatch = control.querySelector('img.product-card-color-swatch');
        if (!swatch) return;
        if (featured_img) featured_img.srcset = swatch.dataset.swatchFeaturedImage;
        if (prod_link) prod_link.href = swatch.dataset.swatchVariantUrl;
        if (featured_img_alt) featured_img_alt.srcset = swatch.dataset.swatchFeaturedImageAlt;

        let reg_price = swatch.dataset.price;
        let comp_price = swatch.dataset.compare;
        if(comp_price){
          if (card.querySelector(".price__sale")) card.querySelector(".price__sale").style="display:flex";
          if (card.querySelector(".price__regular")) card.querySelector(".price__regular").style="display:none !important";
          if (card.querySelector(".price__sale .price-item--sale")) card.querySelector(".price__sale .price-item--sale").innerText = `From ${reg_price}`;
          if (card.querySelector(".price__sale .price-item--regular")) card.querySelector(".price__sale .price-item--regular").innerText = `${comp_price}`;
        }else{
          if (card.querySelector(".price__sale")) card.querySelector(".price__sale").style="display:none !important";
          if (card.querySelector(".price__regular")) card.querySelector(".price__regular").style="display:block";
          if (card.querySelector(".price__regular .price-item--regular")) card.querySelector(".price__regular .price-item--regular").innerText = `${reg_price}`;
        }
      });
    });
  });
};

const updateSwatchesCard = (root = document) => {
  let card_swatches = [
    ...(root.matches?.('div.product-card-color-swatch') ? [root] : []),
    ...root.querySelectorAll('div.product-card-color-swatch'),
  ];
  card_swatches.forEach((colors) => {
    let c = colors.querySelector('.colors');
    if( c ){
      let plus = colors.querySelector('.plus-more');
      const swatchControls = Array.from(c.children).filter((control) => control.matches('.product-card-swatch-button'));
      if( swatchControls.length > 0 ){
        const selectedControl =
          swatchControls.find((control) => {
            const swatch = control.querySelector('img.product-card-color-swatch');
            return control.getAttribute('aria-pressed') === 'true' || swatch.classList.contains('color-selected');
          }) || swatchControls[0];
        swatchControls.forEach((control) => {
          const swatch = control.querySelector('img.product-card-color-swatch');
          swatch.classList.toggle('color-selected', control === selectedControl);
          control.setAttribute('aria-pressed', control === selectedControl ? 'true' : 'false');
        });

        let total_colors = 0;
        for (let i = 0; i < swatchControls.length; i++) {
          if (i >= 4) {
            swatchControls[i].style.display = 'none';
          }
          total_colors += 1;
        }
        if (total_colors > 4) {
          plus.innerText = `+ ${total_colors - 4}`;
        }
  
        swatchControls.forEach((control) => {
          if (control.dataset.swatchStateBound) return;
          control.dataset.swatchStateBound = 'true';
          control.addEventListener('click', () => {
            Array.from(c.children).forEach((item) => {
              if (!item.matches('.product-card-swatch-button')) return;
              const swatch = item.querySelector('img.product-card-color-swatch');
              swatch.classList.remove('color-selected');
              item.setAttribute('aria-pressed', 'false');
            });
            const swatch = control.querySelector('img.product-card-color-swatch');
            swatch.classList.add('color-selected');
            control.setAttribute('aria-pressed', 'true');
          });
        });
      }
    }
  });
};

document.addEventListener('shopify:section:load', (event) => {
  update_swatch_img(event.target);
  updateSwatchesCard(event.target);
});

function isElementVisible(element) {
  if (!element) return false;
  const style = window.getComputedStyle(element);
  return (
    !element.closest('[hidden], [inert]') &&
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    (element.getClientRects().length > 0 || element === document.activeElement)
  );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter(isElementVisible);
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  #preProcessCallbacks = [];
  #postProcessCallbacks = [];

  constructor() {}

  addPreProcessCallback(callback) {
    this.#preProcessCallbacks.push(callback);
  }

  addPostProcessCallback(callback) {
    this.#postProcessCallbacks.push(callback);
  }

  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  viewTransition(oldNode, newContent) {
    this.#preProcessCallbacks.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    this.#postProcessCallbacks.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};
let trappedContainer = null;
let trappedOwner = null;
let lastTabDirection = 1;
const externalInertElements = new WeakMap();
const externalInertOwnerCounts = new WeakMap();
const documentOverflowOwners = new Map();

function setExternalContentInert(container) {
  let inertElements = externalInertElements.get(container);
  if (!inertElements) {
    inertElements = new Set();
    externalInertElements.set(container, inertElements);
  }

  let currentElement = container;
  while (currentElement && currentElement !== document.body) {
    const parentElement = currentElement.parentElement;
    if (!parentElement) break;

    Array.from(parentElement.children).forEach((element) => {
      if (element === currentElement || element.matches('dialog:modal') || inertElements.has(element)) return;

      const ownerCount = externalInertOwnerCounts.get(element) || 0;
      if (element.inert && ownerCount === 0) return;

      element.inert = true;
      inertElements.add(element);
      externalInertOwnerCounts.set(element, ownerCount + 1);
    });
    currentElement = parentElement;
  }
}

function removeExternalContentInert(container) {
  const inertElements = externalInertElements.get(container);
  if (!inertElements) return;

  inertElements.forEach((element) => {
    const ownerCount = externalInertOwnerCounts.get(element) || 0;
    if (ownerCount > 1) {
      externalInertOwnerCounts.set(element, ownerCount - 1);
    } else if (ownerCount === 1) {
      externalInertOwnerCounts.delete(element);
      element.inert = false;
    }
  });
  externalInertElements.delete(container);
}

function setDocumentOverflowHidden(owner, className) {
  let owners = documentOverflowOwners.get(className);
  if (!owners) {
    owners = new Set();
    documentOverflowOwners.set(className, owners);
  }
  owners.add(owner);
  document.body.classList.add(className);
}

function removeDocumentOverflowHidden(owner, className) {
  const owners = documentOverflowOwners.get(className);
  owners?.delete(owner);
  if (owners?.size) return;

  documentOverflowOwners.delete(className);
  if (className === 'overflow-hidden' && trappedOwner && trappedOwner !== owner) return;
  document.body.classList.remove(className);
}

function trapFocus(container, elementToFocus = container, owner = container) {
  removeTrapFocus();
  trappedContainer = container;
  trappedOwner = owner;

  trapFocusHandlers.focusin = (event) => {
    if (document.querySelector('dialog:modal')) return;
    if (event.target === trappedContainer || trappedContainer.contains(event.target)) return;

    const elements = getFocusableElements(trappedContainer);
    const element = lastTabDirection < 0 ? elements[elements.length - 1] : elements[0];
    (element || trappedContainer).focus();
  };

  trapFocusHandlers.keydown = function (event) {
    if (document.querySelector('dialog:modal')) return;
    if (event.code.toUpperCase() !== 'TAB') return;

    lastTabDirection = event.shiftKey ? -1 : 1;
    const elements = getFocusableElements(trappedContainer);
    const first = elements[0];
    const last = elements[elements.length - 1];

    if (!first) {
      event.preventDefault();
      trappedContainer.focus();
      return;
    }

    if (first === last) {
      event.preventDefault();
      first.focus();
      return;
    }

    if (event.shiftKey && (event.target === trappedContainer || event.target === first || !trappedContainer.contains(event.target))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (event.target === last || !trappedContainer.contains(event.target))) {
      event.preventDefault();
      first.focus();
    }
  };

  document.addEventListener('focusin', trapFocusHandlers.focusin, true);
  document.addEventListener('keydown', trapFocusHandlers.keydown, true);

  if (document.querySelector('dialog:modal')) return;

  const initialFocus = isElementVisible(elementToFocus)
    ? elementToFocus
    : getFocusableElements(container)[0] || container;
  initialFocus.focus();

  if (
    initialFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(initialFocus.type) &&
    initialFocus.value
  ) {
    initialFocus.setSelectionRange(0, initialFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null, owner = null) {
  if (owner && trappedOwner !== owner) return false;

  document.removeEventListener('focusin', trapFocusHandlers.focusin, true);
  document.removeEventListener('keydown', trapFocusHandlers.keydown, true);
  trappedContainer = null;
  trappedOwner = null;
  lastTabDirection = 1;

  if (elementToFocus?.isConnected) elementToFocus.focus();
  return true;
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".quantity__button[name='plus']");
    buttonMinus.classList.toggle('disabled', this.input.min && value <= parseInt(this.input.min));
    buttonPlus.classList.toggle('disabled', this.input.max && value >= parseInt(this.input.max));
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.drawerOpen = false;
    this.submenuOpenTasks = new Map();
    this.closeAnimationFrames = new Map();
    this.handleDocumentKeyDown = this.onDocumentKeyDown.bind(this);
    this.refreshBackgroundInert = () => setExternalContentInert(this);
    this.handleClick = this.onClick.bind(this);
    this.handleFocusOut = this.onFocusOut.bind(this);
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
    this.teardownMenuDrawer();
  }

  bindEvents() {
    if (this.eventsBound) return;
    this.eventsBound = true;
    this.addEventListener('click', this.handleClick);
    this.addEventListener('focusout', this.handleFocusOut);
  }

  unbindEvents() {
    if (!this.eventsBound) return;
    this.eventsBound = false;
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('focusout', this.handleFocusOut);
  }

  onClick(event) {
    const summaryElement = event.target.closest('summary');
    if (summaryElement && this.contains(summaryElement)) {
      this.onSummaryClick(event, summaryElement);
      return;
    }

    const closeButton = event.target.closest('.menu-drawer__close-button, .mobile-facets__close-button');
    if (closeButton && this.contains(closeButton)) this.onCloseButtonClick(closeButton);
  }

  onDocumentKeyDown(event) {
    if (!this.drawerOpen || event.code.toUpperCase() !== 'ESCAPE') return;

    event.preventDefault();
    const openDetailsElement = event.target.closest?.('details[open]');
    if (
      openDetailsElement &&
      this.contains(openDetailsElement) &&
      openDetailsElement !== this.mainDetailsToggle &&
      openDetailsElement.classList.contains('menu-opening')
    ) {
      this.closeSubmenu(openDetailsElement);
    } else {
      this.closeMenuDrawer(event);
    }
  }

  onSummaryClick(event, summaryElement) {
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      this.drawerOpen ? this.closeMenuDrawer(event) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      this.cancelCloseAnimation(detailsElement);
      this.cancelSubmenuOpen(detailsElement);
      const task = { submenu: summaryElement.nextElementSibling };
      task.openTimeout = setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        const addTrapFocus = () => {
          this.cancelSubmenuOpen(detailsElement);
          if (!this.drawerOpen || !detailsElement.hasAttribute('open')) return;
          trapFocus(task.submenu, detailsElement.querySelector('button'), this);
        };

        if (reducedMotion.matches) {
          addTrapFocus();
        } else {
          task.transitionHandler = (transitionEvent) => {
            if (transitionEvent.target === task.submenu && transitionEvent.propertyName === 'transform') addTrapFocus();
          };
          task.submenu.addEventListener('transitionend', task.transitionHandler);
          task.fallbackTimeout = setTimeout(addTrapFocus, 500);
        }
      }, 100);
      this.submenuOpenTasks.set(detailsElement, task);
    }
  }

  openMenuDrawer(summaryElement) {
    this.drawerOpen = true;
    this.openedBy = summaryElement;
    clearTimeout(this.focusOutTimeout);
    this.focusOutTimeout = null;
    this.cancelCloseAnimation(this.mainDetailsToggle);
    clearTimeout(this.mainOpenTimeout);
    this.mainOpenTimeout = setTimeout(() => {
      this.mainOpenTimeout = null;
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    setExternalContentInert(this);
    this.backgroundObserver = this.backgroundObserver || new MutationObserver(this.refreshBackgroundInert);
    this.backgroundObserver.disconnect();
    this.backgroundObserver.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('keydown', this.handleDocumentKeyDown);
    trapFocus(this.mainDetailsToggle, summaryElement, this);
    setDocumentOverflowHidden(this, `overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = this.openedBy) {
    if (!this.drawerOpen) return false;

    this.drawerOpen = false;
    clearTimeout(this.focusOutTimeout);
    this.focusOutTimeout = null;
    clearTimeout(this.mainOpenTimeout);
    this.mainOpenTimeout = null;
    this.mainDetailsToggle.classList.remove('menu-opening');
    Array.from(this.submenuOpenTasks.keys()).forEach((details) => this.cancelSubmenuOpen(details));
    Array.from(this.closeAnimationFrames.keys()).forEach((details) => this.cancelCloseAnimation(details));
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('summary').forEach((summary) => {
      summary.setAttribute('aria-expanded', false);
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.removeEventListener('keydown', this.handleDocumentKeyDown);
    this.backgroundObserver?.disconnect();
    removeExternalContentInert(this);
    const returnFocus = elementToFocus?.isConnected ? elementToFocus : this.openedBy?.isConnected ? this.openedBy : null;
    removeTrapFocus(returnFocus, this);
    removeDocumentOverflowHidden(this, `overflow-hidden-${this.dataset.breakpoint}`);
    this.closeAnimation(this.mainDetailsToggle);
    this.openedBy = null;

    return true;
  }

  onFocusOut(event) {
    const nextFocus = event.relatedTarget;
    clearTimeout(this.focusOutTimeout);
    this.focusOutTimeout = setTimeout(() => {
      this.focusOutTimeout = null;
      if (!this.drawerOpen) return;
      const active = document.activeElement;
      // Opening a submenu hides the item that was tapped, so focus drops to the page for a moment. Don't treat that as leaving the menu.
      if (!nextFocus && (!active || active === document.body)) return;
      if (!this.mainDetailsToggle.contains(active)) this.closeMenuDrawer();
    });
  }

  teardownMenuDrawer() {
    this.drawerOpen = false;
    clearTimeout(this.focusOutTimeout);
    clearTimeout(this.mainOpenTimeout);
    this.focusOutTimeout = null;
    this.mainOpenTimeout = null;
    Array.from(this.submenuOpenTasks.keys()).forEach((details) => this.cancelSubmenuOpen(details));
    Array.from(this.closeAnimationFrames.keys()).forEach((details) => this.cancelCloseAnimation(details));
    this.mainDetailsToggle?.removeAttribute('open');
    this.mainDetailsToggle?.classList.remove('menu-opening');
    this.mainDetailsToggle?.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle?.querySelectorAll('summary').forEach((summary) => {
      summary.setAttribute('aria-expanded', false);
    });
    this.mainDetailsToggle?.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.removeEventListener('keydown', this.handleDocumentKeyDown);
    this.backgroundObserver?.disconnect();
    removeExternalContentInert(this);
    removeTrapFocus(null, this);
    removeDocumentOverflowHidden(this, `overflow-hidden-${this.dataset.breakpoint}`);
    this.openedBy = null;
  }

  onCloseButtonClick(closeButton) {
    const detailsElement = closeButton.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    this.cancelSubmenuOpen(detailsElement);
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    trapFocus(this.mainDetailsToggle, detailsElement.querySelector('summary'), this);
    this.closeAnimation(detailsElement);
  }

  cancelSubmenuOpen(detailsElement) {
    const task = this.submenuOpenTasks.get(detailsElement);
    if (!task) return;

    clearTimeout(task.openTimeout);
    clearTimeout(task.fallbackTimeout);
    if (task.transitionHandler) task.submenu?.removeEventListener('transitionend', task.transitionHandler);
    this.submenuOpenTasks.delete(detailsElement);
  }

  cancelCloseAnimation(detailsElement) {
    const animationFrame = this.closeAnimationFrames.get(detailsElement);
    if (animationFrame) cancelAnimationFrame(animationFrame);
    this.closeAnimationFrames.delete(detailsElement);
  }

  closeAnimation(detailsElement) {
    this.cancelCloseAnimation(detailsElement);
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        this.closeAnimationFrames.set(detailsElement, window.requestAnimationFrame(handleAnimation));
      } else {
        this.closeAnimationFrames.delete(detailsElement);
        detailsElement.removeAttribute('open');
        if (this.drawerOpen && detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'), this);
        }
      }
    };

    this.closeAnimationFrames.set(detailsElement, window.requestAnimationFrame(handleAnimation));
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.header?.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    window.addEventListener('resize', this.onResize);
    super.openMenuDrawer(summaryElement);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!super.closeMenuDrawer(event, elementToFocus)) return;
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    if (this.drawerOpen && window.getComputedStyle(this).display === 'none') {
      this.closeMenuDrawer(null, null);
      return;
    }
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    setDocumentOverflowHidden(this, 'overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'), this);
    window.pauseAllMedia();
  }

  hide() {
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy, this);
    removeDocumentOverflowHidden(this, 'overflow-hidden');
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}



customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.currentVariant = this.getVariantData(target.id);
      this.updateSelectedSwatchValue(event);

      publish(PUB_SUB_EVENTS.variantChangeStart, {
        data: {
          event,
          target,
          variant: this.currentVariant,
        },
      });
    });
  }

  // updateVariantDetails(currentVariant){
  //   const variants = document.querySelectorAll('[data-variant-id]')

  //   variants.forEach( function(variant) {
  //       variant.style.display = 'none';
  //       if(variant.dataset.variantId == currentVariant.id){
  //         variant.style.display = 'block'
  //       }
  //     });
  //  }


  // updateOptions(){
  //   // this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  //   console.log("update option")
  //   this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
  //     if (element.tagName === 'SELECT') {
  //       return element.value;
  //     }
  //     if (element.tagName === 'FIELDSET') {
  //       return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
  //     }
  //   });
  // }
  // updateMasterId() {
  //   this.currentVariant = this.getVariantData().find((variant) => {
  //     return !variant.options.map((option, index) => {
  //       document.getElementById("currently-selected-variation").innerHTML = this.options[index];
  //       return this.options[index] === option;
  //     }).includes(false);
  //   });
  // }

  updateSelectedSwatchValue({ target }) {
    console.log("update update selected")
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.currentVariant = this.getVariantData(target.id);
      this.updateSelectedSwatchValue(event);

      publish(PUB_SUB_EVENTS.variantChangeStart, {
        data: {
          event,
          target,
          variant: this.currentVariant,
        },
      });
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  getVariantData(inputId) {
    return JSON.parse(this.getVariantDataElement(inputId).textContent);
  }

  getVariantDataElement(inputId) {
    return this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select, fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

const firstMegaMenuContent = document.getElementById('MegaMenu-Content-1');

if (firstMegaMenuContent) {
  firstMegaMenuContent.addEventListener('mouseleave', () => {
    const activeElement = document.activeElement;
    const focusRemainsInMenu =
      activeElement &&
      firstMegaMenuContent.contains(activeElement) &&
      activeElement.matches(':focus-visible');

    if (focusRemainsInMenu) return;
    removeOpen();
  });
}
var elementToAdd = '';
// document.querySelector('#MegaMenu-Content-1 > .mega-menu__list').insertAdjacentHTML('beforeend', '<svg id="gb-menu-x" onclick=removeOpen() role="img" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="needsclick  kl-private-reset-css-Xuajs1"><circle cx="10" cy="10" r="9.5" fill="#000000" stroke="#FFFFFF" style="cursor: pointer;"></circle><path d="M6 6L14 14M6 14L14 6L6 14Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="cursor: pointer;"></path></svg>');
// onVariantChange
function removeOpen(){
  const firstHeaderMenu = document.getElementById('Details-HeaderMenu-1');
  if (firstHeaderMenu) {
    firstHeaderMenu.removeAttribute('open');
  }
}

window.quickAddToCart = async function (variantID, qty = 1) {
  if (!variantID) return;

  try {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    const url = `${window.Shopify.routes.root}cart/add.js`;
    const data = {
      items: [
        {
          id: variantID,
          quantity: qty,
        },
      ],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
    };
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify(data),
    };

    const response = await fetch(url, config);
    const result = await response.json();
    document.dispatchEvent(new CustomEvent('theme:loading:end'));

    if (response.ok) {
      publish('cart::rerender', {
        productVariantId: variantID,
        cartData: result,
      });
    } else {
      console.error(result.message);
    }
  } catch (error) {
    console.error(error);
  }
};
